exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flip-list-move {\n  transition: -webkit-transform .7s;\n  transition: transform .7s;\n  transition: transform .7s, -webkit-transform .7s;\n}\n", ""]);

// exports
